import { render } from "./ForewordView.vue?vue&type=template&id=531e26ff&scoped=true"
import script from "./ForewordView.vue?vue&type=script&lang=js"
export * from "./ForewordView.vue?vue&type=script&lang=js"

import "./ForewordView.vue?vue&type=style&index=0&id=531e26ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e26ff"]])

export default __exports__